import { regexEmail } from '@/utils/regex';
import { showMessage } from '@/utils/messages';
import {
    initSettingEmailOptionAnswer,
    initSettingEmailOption,
    initFieldAdmin,
    initFieldAnswer,
    OPTION_SENDING_CONDITIONS,
    OPTION_NOT_SELECTED
} from './constants';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { validateAllField } from '@/utils/validate';
import { CONFIG_LAST_EDITOR } from '@/components/Editor/constants';

const onHandleMoreMail = (FieldConfig, type) => {
    let isMail = true;
    switch (type) {
        case 'one':
            // eslint-disable-next-line
            const listMail = formatStringMailtoArray(FieldConfig.valueSync);
            if (listMail?.length === 0) return isMail;
            for (let i = 0; i < listMail.length; i++) {
                const mail = listMail[i].trim();
                if (!mail || !regexEmail(mail)) {
                    isMail = false;
                    FieldConfig.isEmail = true;
                    FieldConfig.error = true;
                    break;
                }
            }
            break;
        case 'all': {
            let isValid = true;
            Object.keys(FieldConfig).forEach((key) => {
                const field = FieldConfig[key];
                if (key.startsWith('configField')) {
                    const listMail = formatStringMailtoArray(field.valueSync);
                    if (listMail?.length === 0) return;
                    for (let i = 0; i < listMail.length; i++) {
                        const mail = listMail[i].trim();
                        if (!mail || !regexEmail(listMail[i])) {
                            isValid = false;
                            field.isEmail = true;
                            field.error = true;
                            break;
                        }
                    }
                }
            });
            isMail = isValid;
            break;
        }
    }
    return isMail;
};

const formatStringMailtoArray = (mailString) => {
    if (!mailString) return [];
    return mailString.split(',').map((item) => item.trim());
};

const onHandleFormatBlockNameToId = (str, listBlock) => {
    let result = str;
    listBlock.forEach((block) => {
        const regex = new RegExp(`<<${block.block_name}>>`, 'g');
        result = result.replace(regex, `<<フォーム:${block.id}>>`);
    });
    return result;
};

const onHandleCheckNoSendAll = (blockTab, bvToast, OPTION_SENDING_CONDITIONS) => {
    let isNotSend = true;
    if (blockTab?.length <= 0 || !blockTab) return isNotSend;
    isNotSend = blockTab.every((item) => item.send_setting === OPTION_SENDING_CONDITIONS[1].id);
    return !isNotSend;
};

const answerOnHandleMapEachOption = (data, BlockId, listBlockMail, listEmailFromAddress) => {
    let valueOption = '';
    let blockType = BlockId?.block_type;
    switch (blockType) {
        case ALL_BLOCK_TYPE.BLOCK_RADIO:
            valueOption = BlockId?.extension.setting_others.label_other;
            break;
    }

    const dataMap = data?.map((item) => {
        if (item.is_custom_value && !item.option_id && !item.is_not_selected) {
            item.value = valueOption;
        } else if (!item.is_custom_value && !item.option_id && item.is_not_selected) {
            item.value = OPTION_NOT_SELECTED[0].value;
        } else {
            item.value = BlockId?.options.find((option) => option.id === item.option_id)?.value ?? '';
        }
        return {
            ...initSettingEmailOptionAnswer(item),
            from_address: listEmailFromAddress.find((mail) => mail.email_address === item.from_address) ?? '',
            to_address: item.to_address?.map((item) => listBlockMail.find((block) => block.id === item || block?.label === item)) ?? [],
            is_custom_value: item.is_custom_value === 1 ? true : false,
            is_not_selected: item.is_not_selected === 1 ? true : false,
            value: item.value
        };
    });
    return dataMap;
};
const adminOnHandleMapEachOption = (data, BlockId) => {
    let valueOption = '';
    let blockType = BlockId?.block_type;
    switch (blockType) {
        case ALL_BLOCK_TYPE.BLOCK_RADIO:
            valueOption = BlockId.extension.setting_others.label_other;
            break;
    }

    const dataMap = data?.map((item) => {
        if (item.is_custom_value && !item.option_id && !item.is_not_selected) {
            item.value = valueOption;
        } else if (!item.is_custom_value && !item.option_id && item.is_not_selected) {
            item.value = OPTION_NOT_SELECTED[0].value;
        } else {
            item.value = BlockId.options.find((option) => option.id === item.option_id)?.value ?? '';
        }
        return {
            ...initSettingEmailOption(item),
            is_custom_value: item.is_custom_value === 1 ? true : false,
            is_not_selected: item.is_not_selected === 1 ? true : false,
            value: item.value
        };
    });
    return dataMap;
};

const onHandleValidateTabs = (
    configDataAdmin,
    formDataAdmin,
    configDataAswer,
    formDataAnswer,
    $refs,
    $bvToast,
    payload,
    checkAllAdmin,
    checkAllClient,
    checkConditionBlockAdmin,
    checkConditionBlockAnswer,
    checkAllMailAdmin,
    checkAllMailClient,
    checkConditionBlockAdminMail,
    checkConditionBlockAnswerMail,
    checkNotSendAllAdminMail,
    checkNotSendAllAnswerMail,
    currentTab
) => {
    if (currentTab === 0) {
        let copyConfig = { ...configDataAdmin };
        delete payload.admin_mail.configEachField;
        delete payload.client_mail;
        switch (formDataAdmin.option_send_email) {
            case 1:
                delete copyConfig.configFieldSelectMailSendingConditions;
                checkAllAdmin = validateAllField(copyConfig);
                checkAllMailAdmin = onHandleMoreMail(
                    {
                        configFieldToAddress: copyConfig.configFieldToAddress,
                        configFieldBccAddress: copyConfig.configFieldBccAddress
                    },
                    'all'
                );
                if (checkAllAdmin && checkAllMailAdmin) {
                    payload = {
                        ...payload,
                        admin_mail: {
                            ...payload.admin_mail,
                            ...formDataAdmin,
                            from_address: formDataAdmin.from_address?.email_address ?? '',
                            choice_reply_address:
                                formDataAdmin.choice_reply_address?.id === 'default' ? [] : [formDataAdmin.choice_reply_address?.id],
                            to_address: formatStringMailtoArray(formDataAdmin.to_address).filter((item) => item !== ''),
                            bcc_address: formatStringMailtoArray(formDataAdmin.bcc_address).filter((item) => item !== ''),
                            email_reply_address: formDataAdmin.email_reply_address?.email_address ?? ''
                        }
                    };
                    delete payload.admin_mail.block_id;
                    delete payload.admin_mail.email_settings_for_each_option;
                }
                break;
            case 2:
                copyConfig = {
                    configFieldFromAddress: configDataAdmin.configFieldFromAddress,
                    configFieldReplyAddress: configDataAdmin.configFieldReplyAddress,
                    configFieldSelectMailSendingConditions: configDataAdmin.configFieldSelectMailSendingConditions
                };
                checkAllAdmin = validateAllField(copyConfig);
                checkConditionBlockAdmin = $refs.alertAdmin[0]?.$refs?.blockSending?.handleValidateAllField() ?? true;
                checkConditionBlockAdminMail = $refs.alertAdmin[0]?.$refs?.blockSending?.onHandleValidateMail() ?? true;
                checkNotSendAllAdminMail =
                    onHandleCheckNoSendAll(formDataAdmin.email_settings_for_each_option, $bvToast, OPTION_SENDING_CONDITIONS) ?? true;
                if (checkAllAdmin && checkConditionBlockAdmin && checkConditionBlockAdminMail && checkNotSendAllAdminMail) {
                    payload = {
                        ...payload,
                        admin_mail: {
                            ...payload.admin_mail,
                            ...formDataAdmin,
                            to_address: null,
                            bcc_address: [],
                            subject: null,
                            main_text: null,
                            masking_personal_information_fields: formDataAdmin.masking_personal_information_fields,
                            from_address: formDataAdmin.from_address?.email_address ?? '',
                            choice_reply_address:
                                formDataAdmin.choice_reply_address?.id === 'default' ? [] : [formDataAdmin.choice_reply_address?.id],
                            email_reply_address: formDataAdmin.email_reply_address?.email_address ?? '',
                            block_id: formDataAdmin.block_id?.id ?? null,
                            email_settings_for_each_option: formDataAdmin.email_settings_for_each_option.map((item) => {
                                const isNotSend = item.send_setting === OPTION_SENDING_CONDITIONS[1].id;
                                return {
                                    to_address: isNotSend ? [] : formatStringMailtoArray(item.to_address).filter((item) => item !== ''),
                                    bcc_address: isNotSend ? [] : formatStringMailtoArray(item.bcc_address).filter((item) => item !== ''),
                                    option_id: item?.is_custom_value || item?.is_not_selected ? null : item.option_id,
                                    is_not_selected: item.is_not_selected,
                                    is_custom_value: item?.is_custom_value ?? false,
                                    main_text: isNotSend ? null : item.main_text,
                                    send_setting: item.send_setting,
                                    subject: isNotSend ? null : item.subject
                                };
                            })
                        }
                    };
                }
                break;
            case 3:
                payload = {
                    ...payload,
                    admin_mail: {
                        ...payload.admin_mail,
                        ...initFieldAdmin(),
                        option_send_email: formDataAdmin.option_send_email,
                        choice_reply_address: [],
                        main_text: '',
                        subject: ''
                    }
                };
                break;
        }
    }
    if (currentTab === 1) {
        let copyConfigAnswer = { ...configDataAswer };
        delete payload.client_mail.configEachField;
        delete payload.admin_mail;
        switch (formDataAnswer.option_send_email) {
            case 1:
                delete copyConfigAnswer.configFieldSelectMailSendingConditions;
                checkAllClient = validateAllField(copyConfigAnswer);
                checkAllMailClient = onHandleMoreMail(
                    {
                        configFieldBccAddress: copyConfigAnswer.configFieldBccAddress
                    },
                    'all'
                );
                if (checkAllClient && checkAllMailClient) {
                    payload = {
                        ...payload,
                        client_mail: {
                            ...payload.client_mail,
                            ...formDataAnswer,
                            from_address: formDataAnswer.from_address?.email_address ?? '',
                            bcc_address: formatStringMailtoArray(formDataAnswer.bcc_address).filter((item) => item !== '') ?? [],
                            to_address: formDataAnswer.to_address.map((item) => item?.id) ?? []
                        }
                    };
                    delete payload.client_mail.block_id;
                    delete payload.client_mail.email_settings_for_each_option;
                }
                break;
            case 2:
                copyConfigAnswer = {
                    configFieldSelectMailSendingConditions: configDataAswer.configFieldSelectMailSendingConditions
                };
                checkAllClient = validateAllField(copyConfigAnswer);
                checkConditionBlockAnswer = $refs.alertAnswer[0]?.$refs?.blockSendingAnswer?.handleValidateAllField() ?? true;
                checkConditionBlockAnswerMail = $refs.alertAnswer[0]?.$refs?.blockSendingAnswer?.onHandleValidateMail() ?? true;
                checkNotSendAllAnswerMail =
                    onHandleCheckNoSendAll(formDataAnswer.email_settings_for_each_option, $bvToast, OPTION_SENDING_CONDITIONS) ?? true;
                if (checkAllClient && checkConditionBlockAnswer && checkConditionBlockAnswerMail && checkNotSendAllAnswerMail) {
                    payload = {
                        ...payload,
                        client_mail: {
                            ...payload.client_mail,
                            ...formDataAnswer,
                            from_address: null,
                            to_address: [],
                            bcc_address: [],
                            subject: null,
                            main_text: null,
                            block_id: formDataAnswer.block_id?.id ?? null,
                            email_settings_for_each_option: formDataAnswer?.email_settings_for_each_option.map((item) => {
                                const isNotSend = item.send_setting === OPTION_SENDING_CONDITIONS[1].id;
                                return {
                                    bcc_address: isNotSend ? [] : formatStringMailtoArray(item.bcc_address).filter((item) => item !== ''),
                                    to_address: isNotSend ? [] : item.to_address.map((item) => item?.id) ?? [],
                                    from_address: isNotSend ? null : item.from_address.email_address,
                                    option_id: item?.is_custom_value || item?.is_not_selected ? null : item.option_id,
                                    is_not_selected: item.is_not_selected,
                                    is_custom_value: item?.is_custom_value ?? false,
                                    main_text: isNotSend ? null : item.main_text,
                                    send_setting: item.send_setting,
                                    subject: isNotSend ? null : item.subject
                                };
                            })
                        }
                    };
                }
                break;
            case 3:
                payload = {
                    ...payload,
                    client_mail: {
                        ...payload.client_mail,
                        ...initFieldAnswer(),
                        to_address: [],
                        choice_reply_address: [],
                        main_text: '',
                        subject: ''
                    }
                };
                break;
        }
    }

    return {
        payload,
        checkAllAdmin,
        checkAllClient,
        checkConditionBlockAdmin,
        checkConditionBlockAnswer,
        checkAllMailAdmin,
        checkAllMailClient,
        checkConditionBlockAdminMail,
        checkConditionBlockAnswerMail,
        checkNotSendAllAdminMail,
        checkNotSendAllAnswerMail
    };
};

const onHandleShowMessageValidateTabs = (bvToast, validateAdmin, validateClient) => {
    let checkValidate = false;
    let { checkAllAdmin, checkAllMailAdmin, checkConditionBlockAdmin, checkConditionBlockAdminMail, checkNotSendAllAdminMail } = validateAdmin;
    let { checkAllClient, checkAllMailClient, checkConditionBlockAnswer, checkConditionBlockAnswerMail, checkNotSendAllAnswerMail } = validateClient;
    if (
        !checkAllAdmin ||
        !checkAllMailAdmin ||
        !checkConditionBlockAdmin ||
        !checkConditionBlockAdminMail ||
        !checkNotSendAllAdminMail ||
        !checkAllClient ||
        !checkAllMailClient ||
        !checkConditionBlockAnswer ||
        !checkConditionBlockAnswerMail ||
        !checkNotSendAllAnswerMail
    ) {
        checkValidate = true;
        showMessage(422, bvToast, '入力内容に問題があります。以下ご確認ください。');
    }
    return checkValidate;
};

const onHandleFilterOptionSendEmail = (listBlock, optionSendEmail) => {
    const someBlock = listBlock.some((block) =>
        [
            ALL_BLOCK_TYPE.BLOCK_RADIO,
            ALL_BLOCK_TYPE.BLOCK_SELECT,
            ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
            ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE
        ].includes(block.block_type)
    );
    if (!someBlock) {
        return optionSendEmail.filter((item) => item.id !== 2);
    }
    return optionSendEmail;
};

const onHandleEditorConfigWithoutVideo = () => {
    return {
        height: 300,
        plugins: CONFIG_LAST_EDITOR.plugins.replace(' media', ''),
        toolbar: CONFIG_LAST_EDITOR.toolbar.replace(' media', ''),
        file_picker_types: 'image'
    };
};

export {
    onHandleMoreMail,
    formatStringMailtoArray,
    onHandleFormatBlockNameToId,
    onHandleCheckNoSendAll,
    answerOnHandleMapEachOption,
    adminOnHandleMapEachOption,
    onHandleValidateTabs,
    onHandleShowMessageValidateTabs,
    onHandleFilterOptionSendEmail,
    onHandleEditorConfigWithoutVideo
};
